var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowFwd = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 24,
  viewBox: "0 0 16 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.75414 16.3159L2.2186 12.7803C1.92571 12.4874 1.92571 12.0126 2.2186 11.7197L5.75414 8.18412C6.04703 7.89123 6.5219 7.89123 6.8148 8.18412C7.10769 8.47702 7.10769 8.95189 6.8148 9.24478L4.56 11.5005L13.25 11.5C13.6297 11.5 13.9435 11.7821 13.9932 12.1482L14 12.25C14 12.6642 13.6642 13 13.25 13L4.56 13.0005L6.8148 15.2552C7.10769 15.5481 7.10769 16.023 6.8148 16.3159C6.5219 16.6087 6.04703 16.6087 5.75414 16.3159Z",
  fill: "#0C2447"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowFwd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-fwd.7cf67149.svg";
export { ForwardRef as ReactComponent };